/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Roll-Up Reporting — portfolios across your sites. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["rollup-reporting"] = "1.0.3"; } catch (e) {}
  /* A roll-up combines several sites into one number, and the one thing people get wrong is
     visitors. Sessions and pageviews add up cleanly; unique visitors do not — the ids are salted
     PER SITE, so the same human on two of your sites is two different hashes and cannot be
     de-duplicated. Portfolio visitors are therefore a SUM, and the tooltip says so rather than
     letting the number imply a precision it does not have. */
  var TYPE_HELP = {
    portfolio: TR('rollup.f3.portfolio_u2014_every_site_you_own'),
    category:  TR('rollup.g.category_u2014_sites_grouped_by_the_'),
    region:    TR('rollup.g.region_u2014_sites_grouped_by_region'),
    custom:    TR('rollup.p.custom_u2014_the_sites_you_picked_by')
  };
  function typeHelp(t) { return TYPE_HELP[String(t || "").toLowerCase()] || ("Grouping: " + (t || "custom")); }
  function rollupName(r) {
    var t = [];
    if (r.sites != null) t.push("Combines " + r.sites + " site" + (r.sites === 1 ? "" : "s") + ".");
    t.push(typeHelp(r.type));
    t.push(TR('rollup.f3.sessions_pageviews_and_revenue_add'));
    t.push("Visitors are a SUM, not a de-duplicated count: visitor ids are salted per site, so the same person on two of your sites cannot be recognised as one. Cross-site de-duplication is impossible by design \u2014 that is the privacy trade.");
    if (r.created) t.push("Created " + r.created);
    return '<span class="rr-nm" title="' + esc(t.join("\n")) + '">' + esc(r.name) + "</span>";
  }

  var root, ROLLUPS=[], SITES=[], CUR=null;
  function q(n){ return root?root.querySelector('[data-d="'+n+'"]'):null; }
  function qa(s){ return root?Array.prototype.slice.call(root.querySelectorAll(s)):[]; }
  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function nf(n){ return (+n||0).toLocaleString(); }
  function ic(n){ return (window.GSIcons&&GSIcons.svg)?(GSIcons.svg(n,15)+" "):""; }
  function ready(fn){ var d=false; function go(){ if(d)return; d=true; fn(); }
    document.addEventListener("gs:ready",go,{once:true});
    var n=0,t=setInterval(function(){ if(window.GS&&GS.api&&GS.site){clearInterval(t);go();} else if(++n>200)clearInterval(t); },30);
    if(window.GS&&GS.api&&GS.site)go(); }
  function api(path,opts){ return GS.api(path+(path.indexOf("?")<0?"?":"&")+"site="+encodeURIComponent(GS.site),opts); }

  function loadList(){ api("/plugin/rollup-reporting/list").then(function(r){ ROLLUPS=(r.ok&&r.data&&r.data.rollups)||[]; renderList(); }); }
  function renderList(){
    var tb=q("list-tbody");
    function rrRow(r){
      return '<tr data-row="'+r.id+'"><td class="nm">'+ic("rollup-reporting")+rollupName(r)+"</td><td><span class=\"rr-type\" title=\""+esc(typeHelp(r.type))+"\">"+esc(r.type)+"</span></td>"+
        '<td class="r">'+r.site_count+"</td>"+
        '<td class="ar"><button class="lnk" data-edit="'+r.id+'">'+TR('rollup.g.edit')+'</button> <button class="lnk del" data-del="'+r.id+'">'+TR('rollup.g.delete')+'</button></td></tr>';
    }
    if (window.GSMore) GSMore.mount({ container:tb, table:true, colspan:4, items:ROLLUPS, pageSize:20, emptyText:TR('rollup.f3.no_roll_ups_yet_create_one_to_comb'), render:rrRow });
    else tb.innerHTML = ROLLUPS.length ? ROLLUPS.map(rrRow).join("") : '<tr><td colspan="4" class="empty">'+TR('rollup.f2.no_roll_ups_yet')+'</td></tr>';
    // One delegated listener for rows plus their edit/delete buttons.
    if(!tb._rrDel){ tb._rrDel=1; tb.addEventListener("click",function(e){
      var ed=e.target.closest&&e.target.closest("[data-edit]"); if(ed){ openBuilder(+ed.getAttribute("data-edit")); return; }
      var dl=e.target.closest&&e.target.closest("[data-del]");  if(dl){ delRollup(+dl.getAttribute("data-del")); return; }
      var tr=e.target.closest&&e.target.closest("tr[data-row]");
      if(tr){ var _id=+tr.getAttribute("data-row"), _r=ROLLUPS.filter(function(x){return +x.id===_id;})[0];
        // openDash() titles the dashboard from `name`; omitting it would head every roll-up "Roll-up".
        openDash(_id, _r ? _r.name : ""); } }); }
  }

  /* Portfolio spark: still a sparkline (it sits in a 52px strip), but it no longer hides its numbers —
     the peak is labelled and every point has a hover readout via data-tip. */
  function nfmt(v){ if (window.GSUI && GSUI.fmt) return GSUI.fmt(v);
    v=+v||0; return v>=1e6?(v/1e6).toFixed(1)+"M":v>=1e3?(v/1e3).toFixed(1)+"k":String(Math.round(v)); }
  function spark(vals, days){ if(!vals.length)return '<div class="gs-muted small">'+TR('rollup.g.no_data')+'</div>';
    days=days||[];
    var max=Math.max.apply(null,vals)||1, n=vals.length;
    var W=Math.max(n*10,160), H=48, T=10, B=4, PH=H-T-B;
    var X=function(i){ return n<2 ? W/2 : i/(n-1)*W; };
    var Y=function(v){ return T+PH-((+v||0)/max)*PH; };
    var pts=vals.map(function(v,i){ return X(i).toFixed(1)+","+Y(v).toFixed(1); }).join(" ");
    var colw=n>1?W/(n-1):W, hit="";
    vals.forEach(function(v,i){
      var d=days[i]?String(days[i]):('Day '+(i+1));
      hit+='<rect x="'+(X(i)-colw/2).toFixed(1)+'" y="'+T+'" width="'+colw.toFixed(1)+'" height="'+PH+
           '" fill="transparent" data-tip="'+d+' \u2014 '+nfmt(v)+'"></rect>'; });
    var pi=vals.indexOf(max), lx=X(pi), anchor=pi===0?'start':(pi===n-1?'end':'middle');
    var peak='<text x="'+lx.toFixed(1)+'" y="'+Math.max(8,(Y(max)-4)).toFixed(1)+'" text-anchor="'+anchor+
             '" font-size="9" fill="#6b7280">peak '+nfmt(max)+'</text>';
    return '<svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid meet" style="width:100%;height:52px" '+
      'role="img" aria-label="Trend, peak '+nfmt(max)+'">'+
      '<polyline points="'+pts+'" fill="none" stroke="#1FA463" stroke-width="2" stroke-linejoin="round"/>'+
      '<polyline points="0,'+(T+PH)+' '+pts+' '+W+','+(T+PH)+'" fill="rgba(31,164,99,.10)" stroke="none"/>'+
      peak+hit+'</svg>'; }

  function openDash(id,name){
    if (window.GSLink) window.GSLink.write({ id: id });   // the open dashboard becomes linkable
    CUR=id;
    api("/plugin/rollup-reporting/stats?id="+id).then(function(r){
      if(!r.ok||!r.data)return; var d=r.data, T=d.totals||{};
      var dash=q("dash"); dash.hidden=false; q("dash-title").textContent=name||"Roll-up"; q("dash-sub").textContent=(d.site_count||0)+" sites";
      q("k-pv").textContent=nf(T.pageviews); q("k-vis").textContent=nf(T.visitors); q("k-ev").textContent=nf(T.events);
      var rw=q("k-rev-wrap"); if((T.revenue||0)>0){ rw.hidden=false; q("k-rev").textContent=(T.revenue||0).toLocaleString(undefined,{minimumFractionDigits:2}); } else rw.hidden=true;
      q("timeline").innerHTML=spark((d.timeline||[]).map(function(x){return x.pageviews;}));
      var mx=Math.max.apply(null,(d.sites||[]).map(function(s){return s.pageviews;}).concat([1]));
      q("sites-tbody").innerHTML=(d.sites||[]).map(function(s){
        return '<tr><td class="nm">'+esc(s.name)+'<div class="rr-dom gs-muted">'+esc(s.domain||"")+'</div></td>'+
          '<td class="pvcell"><div class="pvwrap"><span class="rr-b"><i style="width:'+Math.max(2,s.pageviews/mx*100)+'%"></i></span><span class="pvn">'+nf(s.pageviews)+'</span></div></td>'+
          '<td class="r">'+nf(s.visitors)+"</td><td class=\"r\">"+nf(s.events)+"</td><td class=\"r\">"+(s.revenue>0?s.revenue.toLocaleString(undefined,{minimumFractionDigits:2}):"—")+"</td></tr>";
      }).join("")||'<tr><td colspan="5" class="empty">'+TR('rollup.f2.no_sites_in_this_roll_up')+'</td></tr>';
      dash.scrollIntoView({behavior:"smooth",block:"nearest"});
    });
  }

  // builder
  function openBuilder(id){
    var m=q("rr-modal");
    api("/plugin/rollup-reporting/sites").then(function(r){ SITES=(r.ok&&r.data&&r.data.sites)||[]; return id?api("/plugin/rollup-reporting/get?id="+id):null; }).then(function(gr){
      var ru=gr&&gr.ok&&gr.data&&gr.data.rollup?gr.data.rollup:null;
      var chosen={}; if(ru)(ru.sites||[]).forEach(function(s){ chosen[s.site_id]=1; });
      m.querySelector('[data-f="id"]').value= ru?ru.id:"";
      m.querySelector('[data-f="name"]').value= ru?ru.name:"";
      m.querySelector('[data-f="type"]').value= ru?ru.type:"portfolio";
      q("rr-sitelist").innerHTML= SITES.length? SITES.map(function(s){
        return '<label class="rr-site"><input type="checkbox" value="'+s.id+'" '+(chosen[s.id]?"checked":"")+'> <span class="rr-sname">'+esc(s.name)+'</span> <span class="gs-muted">'+esc(s.domain||"")+'</span></label>';
      }).join("") : '<div class="gs-muted small">'+TR('rollup.g.you_have_no_other_sites_to_add')+'</div>';
      q("rr-mtitle").textContent= id?"Edit roll-up":TR('rollup.g.new_roll_up'); m.hidden=false;
    });
  }
  function saveBuilder(){
    var m=q("rr-modal");
    var sites=Array.prototype.slice.call(q("rr-sitelist").querySelectorAll("input:checked")).map(function(i){return +i.value;});
    var body={action:"save",id:+m.querySelector('[data-f="id"]').value||0,name:m.querySelector('[data-f="name"]').value,type:m.querySelector('[data-f="type"]').value,sites:sites};
    api("/plugin/rollup-reporting/create",{method:"POST",body:JSON.stringify(body)}).then(function(r){ if(r.ok){ m.hidden=true; loadList(); } });
  }
  function delRollup(id){ if(!confirm(TT('ru.x.delete_this_roll_up_your_sites_and')))return; api("/plugin/rollup-reporting/create",{method:"POST",body:JSON.stringify({action:"delete",id:id})}).then(function(){ if(CUR===id)q("dash").hidden=true; loadList(); }); }

  function _ymd(d){ return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2); }
  function _today(){ var t=new Date(); return new Date(Date.UTC(t.getFullYear(),t.getMonth(),t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days){ var to=_today(),from=new Date(to.getTime()-(days-1)*86400000); var lbl={7:T("an.last7"),30:T("an.last30"),90:T("an.last90")}[days]||T("an.lastndays",{n:days}); return {from:_ymd(from),to:_ymd(to),label:lbl,preset:String(days)}; }
  var RANGE=(function(){ try{ var s=JSON.parse(localStorage.getItem("gs_rr_range")||"null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if(s&&s.from)return s; }catch(e){} return preset(30); })();
  function reload(){ loadList(); if(CUR)openDash(CUR,q("dash-title").textContent); }
  function initRange(){
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label"); if(!btn)return;
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    btn.addEventListener("click",function(e){ if(menu.contains(e.target)&&e.target!==btn)return; e.stopPropagation(); menu.style.display=menu.style.display==="none"?"block":"none"; });
    document.addEventListener("click",function(){ menu.style.display="none"; });
    menu.addEventListener("click",function(e){ e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){ b.addEventListener("click",function(){ RANGE=preset(+b.getAttribute("data-preset")); if(lab)lab.textContent=RANGE.label; try{localStorage.setItem("gs_rr_range",JSON.stringify(RANGE));}catch(e){} menu.style.display="none"; reload(); }); });
    var _ap=menu.querySelector('[data-rp="apply"]');if(_ap)_ap.addEventListener("click",function(){var ff=(menu.querySelector('[data-rp="from"]')||{}).value,tt=(menu.querySelector('[data-rp="to"]')||{}).value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}RANGE={from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null};if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_rollup-reporting_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";reload();});
    btn.addEventListener("click",function(){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf&&RANGE.from)cf.value=RANGE.from;if(ct&&RANGE.to)ct.value=RANGE.to;});
  }
  // pass range on stats calls
  var _openDash=openDash; openDash=function(id,name){ CUR=id;
    api("/plugin/rollup-reporting/stats?id="+id+"&from="+RANGE.from+"&to="+RANGE.to).then(function(r){
      if(!r.ok||!r.data)return; var d=r.data, T=d.totals||{};
      var dash=q("dash"); dash.hidden=false; q("dash-title").textContent=name||"Roll-up"; q("dash-sub").textContent=(d.site_count||0)+" sites";
      q("k-pv").textContent=nf(T.pageviews); q("k-vis").textContent=nf(T.visitors); q("k-ev").textContent=nf(T.events);
      var rw=q("k-rev-wrap"); if((T.revenue||0)>0){ rw.hidden=false; q("k-rev").textContent=(T.revenue||0).toLocaleString(undefined,{minimumFractionDigits:2}); } else rw.hidden=true;
      q("timeline").innerHTML=spark((d.timeline||[]).map(function(x){return x.pageviews;}));
      var mx=Math.max.apply(null,(d.sites||[]).map(function(s){return s.pageviews;}).concat([1]));
      q("sites-tbody").innerHTML=(d.sites||[]).map(function(s){
        return '<tr><td class="nm">'+esc(s.name)+'<div class="rr-dom gs-muted">'+esc(s.domain||"")+'</div></td>'+
          '<td class="pvcell"><div class="pvwrap"><span class="rr-b"><i style="width:'+Math.max(2,s.pageviews/mx*100)+'%"></i></span><span class="pvn">'+nf(s.pageviews)+'</span></div></td>'+
          '<td class="r">'+nf(s.visitors)+"</td><td class=\"r\">"+nf(s.events)+"</td><td class=\"r\">"+(s.revenue>0?s.revenue.toLocaleString(undefined,{minimumFractionDigits:2}):"—")+"</td></tr>";
      }).join("")||'<tr><td colspan="5" class="empty">'+TR('rollup.f2.no_sites_in_this_roll_up')+'</td></tr>';
    });
  };

  function init(){
    root=document.querySelector('[data-d="root"]'); if(!root)return;
    q("new-rr").onclick=function(){ openBuilder(0); };
    q("rr-save").onclick=saveBuilder;
    ["rr-close","rr-cancel"].forEach(function(k){ q(k).onclick=function(){ q("rr-modal").hidden=true; }; });
    initRange(); loadList();
  }
  /* Deep link: /rollup-reporting?id=<n>.
     openDash(id, name) uses name for the title, and a URL has no name in it. Passing "" would open
     the right dashboard under the wrong heading. So wait for the list and click the real row —
     the exact path a person takes, title included, no second source of truth. Gives up after ~3s. */
  function gsDeep() {
    var id = null;
    if (window.GSLink) id = window.GSLink.read({ id: "int" }).id;
    else {
      try {
        var p = new URLSearchParams(location.search);
        var _n = parseInt(String(p.get("id") || "").replace(/[^0-9-]/g, ""), 10);
        id = isNaN(_n) ? null : _n;
      } catch (e) { id = null; }
    }
    if (id === null) return;
    var n = 0, t = setInterval(function () {
      var tr = document.querySelector('tr[data-row="' + id + '"]');
      if (tr) { clearInterval(t); tr.click(); }
      else if (++n > 60) clearInterval(t);     // deleted, or not visible to this user
    }, 50);
  }
  ready(function () { init(); gsDeep(); });
})();
